import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';


export class ServiceUtil {

  // extrai lista da resposta http
  public extractData(res: any) {
    return res.data || { };
  }

  // manipula erros da resposta http
  public handleError(err: HttpErrorResponse | any): Observable<any> {
		let errMsg: string;

		// Atualização dos status de erros para melhor resposta ao usuário.
		/*
		if (err.message) {
			errMsg = err.message;
		} else if (err.status == 404) {
			errMsg = "Servidor de dados indisponível. Tente mais tarde!";
		} else if (err.status == 401) {
			errMsg = "Acesso negado para a funcionalidade requisitada!";
		} else if (err.status == 400) {
			errMsg = "Solicitação inválida. Tente mais tarde!";
		} else if (err.status == 500) {
			errMsg = "Erro interno do servidor. Tente mais tarde!";
		} else {
			errMsg = "Erro indeterminado. Consulte o administrador do sistema!"
		}
		*/

		switch (err.status) {
			case 400:
				errMsg = "Solicitação inválida. Tente mais tarde!";
				break;
			case 401:
				errMsg = "Acesso negado para a funcionalidade requisitada!";
				break;
			case 403:
				errMsg = "Autenticação necessária!";
				break;
			case 404:
				errMsg = "Servidor de dados indisponível. Tente mais tarde!";
				break;
			case 444:
				errMsg = "Servidor de dados não respondeu à requisição!";
				break;
			case 500:
				errMsg = "Erro interno do servidor. Tente mais tarde!";
				break;
			case 501:
				errMsg = "Funcionalidade não implementada!";
				break;
			case 503:
				errMsg = "Serviço indisponível. Tente mais tarde!";
				break;
			case 511:
				errMsg = "Autenticação de rede necessária!";
				break;
			case 598:
				errMsg = "A rede demorou para responder à requisição!";
				break;
			case 599:
				errMsg = "A rede demorou para estabelecer uma conexão!";
				break;
			default:
				if (err.message) {
					errMsg = err.message;
				} else {
					errMsg = "Erro indeterminado. Consulte o administrador do sistema!"
				}
				break;
		}
		return throwError(errMsg);
	}
}
